import { render, staticRenderFns } from "./CadastrarNovoCredor.vue?vue&type=template&id=16e0ab28&scoped=true"
import script from "./CadastrarNovoCredor.vue?vue&type=script&lang=js"
export * from "./CadastrarNovoCredor.vue?vue&type=script&lang=js"
import style0 from "./CadastrarNovoCredor.vue?vue&type=style&index=0&id=16e0ab28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e0ab28",
  null
  
)

export default component.exports